<template>
    <v-list-item>
        <v-list-item-content>
            <v-list-item-title>{{ concert.title }}</v-list-item-title>
            <v-list-item-subtitle>
                {{ concert.date | date('dddd D MMMM YYYY') }}
                dès
                {{ concert.date | date('HH:mm')}}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
                <a target="_blank" :href="map">{{ concert.address }}</a>
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
            <a target="_blank" :href="concert.url">
                <v-icon>$vuetify.icons.concertMore</v-icon>
            </a>
        </v-list-item-icon>
    </v-list-item>
</template>

<script>
export default {
    name: 'jazz-concert',
    props: {
        concert: { type: Object, required: true }
    },
    computed: {
        map() {
            return `https://map.search.ch/${this.concert.address}`
        }
    }
}
</script>
